import './AgentList.scss';
import Component from './AgentList.js';
export default Component;
